module.exports = __webpack_public_path__ + "img/export.e997ebfe.svg";